import { Button } from "@components/ui/Button";
import { Image } from "@components/ui/Image";
import { Title } from "@components/ui/Title";
import {
  TourCardFragment,
  Tour,
  TourStatus,
  SupplierCardFragment,
} from "@graphql/types";
import { useAuth } from "@helpers/hooks/useAuth";
import { Trans } from "@helpers/translate";
import { ROUTES } from "@root/routes";
import { useRouter } from "next/router";
import React, { FC } from "react";

interface RequestTourProps {
  supplier: SupplierCardFragment;
  tourId: number;
  tour: TourCardFragment;
}

export const RequestTour: FC<RequestTourProps> = ({
  tour,
  supplier,
  tourId,
}) => {
  const isInvalidTour = (tour: Tour) => {
    return tour.status === TourStatus.Inactive || tour.supplier.isBan;
  };

  const alt = `${tour.city.name || ""} Tour Guide - ${supplier.displayName}`;

  const { auth } = useAuth();

  const router = useRouter();

  const sendMessage = () => {
    if (auth) {
      router.push(
        ROUTES.supplier(supplier.id).message.form({
          tourId: tourId,
        })
      );
      return;
    }

    router.push(
      ROUTES.supplier(supplier.id).message.signup({
        tourId: tourId,
      })
    );
  };

  return (
    <div className="mb-20">
      <Title as="h2" size="md" divider>
        <Trans id="tour.block.request-tour.title">
          Want to personalize this tour?
        </Trans>
      </Title>
      <div className="flex w-full">
        <div className="hidden md:block">
          <div className="w-44 h-44 relative">
            <Image
              src={supplier.picture?.url || ""}
              className="object-cover rounded-full"
              fill={true}
              alt={alt}
              activeCache={true}
            />
          </div>
        </div>
        <div className="w-full pl-0 md:pl-4 flex flex-wrap content-between">
          <p className=" text-xl ml-0 md:ml-2">
            <Trans id="tour.block.request-tour.item-1">
              This tour can be customized to meet your needs and preferences.
              Click below to send me a message with your requests.
            </Trans>
          </p>

          <div className="mt-4 w-full">
            <Button
              className="w-full bg-blue-700"
              disabled={isInvalidTour(tour as Tour)}
              rounded
              onClick={sendMessage}
              title="GoWithGuide - Send a Message"
              variant="secondary"
            >
              <Trans id="tour.block.request-tour.button">Send a Message</Trans>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
